var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page",attrs:{"id":"material-dark"}},[_c('div',{staticClass:"page-inner"},[_c("material-dark",{tag:"component"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }